import { apiRequest } from '../core';


export function FileUrl(fileId, width, height) {
  const url = new URL(`${process.env.REACT_APP_FILE_SERVICE_URL}/api/files/${fileId}`);

  const params = {};
  if (width) {
    params.width = width;
  }
  if (height) {
    params.height = height;
  }

  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return url;
}

export function MaterialUrl(fileId) {
    //const url = new URL(`${process.env.REACT_APP_FILE_SERVICE_URL}/api/trainingmaterials/${fileId}`);
    const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/trainingmaterials/${fileId}`);
    return url;
}

export function MaterialPdfUrl(fileId) {
  const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/trainingmaterials/pdf/${fileId}`);
  return url;
}

export function GetFile(fileId) {
  const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/Files/${fileId}`);
  return apiRequest(url);
}


export function FileDownloadUrl(fileId) {
  const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/files/download/${fileId}`);
  return url;
}

export function FilePdfUrl(fileId) {
    const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/files/pdf/${fileId}`);
    return url;
}